import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props)  {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<svg id="Layer_1" height="100%" viewBox="0 0 64 64" width="100%" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m32 3a20.78 20.78 0 0 0 -21 21c0 15.62 18.75 35.54 19.55 36.38a2 2 0 0 0 2.9 0c.8-.84 19.55-20.75 19.55-36.38a20.78 20.78 0 0 0 -21-21zm0 53c-4.35-4.95-17-20.33-17-32a16.63 16.63 0 0 1 17-17 16.63 16.63 0 0 1 17 17c0 11.67-12.65 27.07-17 32z"/><path d="m32 13a11 11 0 1 0 11 11 11 11 0 0 0 -11-11zm0 18a7 7 0 1 1 7-7 7 7 0 0 1 -7 7z"/></svg>`,
      }}
    />
  );
};
